// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container{
    margin-top:110px;
    display: flex;
    flex-direction: column;
}

.contact-details-container{
    display: flex;
    flex-direction: row;
}

.contact-form{
    width:100%;
    height:100%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    margin: 20px 100px;
    margin-right: 50px;
    display: flex;
    flex-direction: column;
    padding: 50px;

}

.contact-form h5{
    text-align: left;
    font-family: 'Poppins',sans-serif;
    font-size: 15px;
    font-weight: 400px;
    letter-spacing: 1px;
    color:#f9c12e;
    margin-top: 0px;
    margin-bottom: 0px;

}

.contact-form h1 {
    text-align: left;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 400px;
    letter-spacing: 1px;
    margin-top: 0px;
    color:#333333

}

.input-fields{
    display: flex;
    flex-direction: row;
    margin-top:30px;
}
.input{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 20px;
   
}

.input label{
    text-align: left;
    font-family: 'Raleway',sans-serif;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 0px;
    
}

.input label span{
    color:red;
    font-size: 24px;
    margin-top:10px;
    margin-left: 10px;
}

.input input{
    height:40px;
    width:275px;
}

.input select{
    height:45px;
    width:275px;
}

.input textarea {
    height: 80px;
    width: 580px;
}

.contact-form button{
    width:150px;
    height:50px;
    margin: 20px 0px;
    background-color:#E42727;
    border-radius: 5px;
    color:#fff;
    position: relative;
    overflow: hidden;
        cursor: pointer;
    
        z-index: 0;
}

         
    
     
    
    
.contact-form button::after {
             /* this is what all  will be done when mouse outs from the button */
             content: "";
             position: absolute;
             left: 0;
             top: 0;
             height: 100%;
             width: 100%;
             background-color: #ffa406;
             z-index: -1;
             
             transition: 0.3s ease all;
             transform: scale(0, 1);
    
             /* this is you are to change for diffirent transition; */
    
             transform-origin: bottom left;
             transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
             transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
         }
    
    
    
         .contact-form button:hover::after {
             transform: scale(1, 1);
             transform-origin: top left;
         }

.contact-information{
       width: 30%;
        height: 100%;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        background-color: #fff;
        margin: 20px ;
        margin-right:100px;
        display: flex;
        flex-direction: column;
        padding: 50px;
}

.information-section{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}

.information-section .icon{
    background-color:#f9c12e;
    width:40px;
    height:40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;

}

.information-section h5{
    font-size: 18px;
    font-family: 'Poppins',sans-serif;
    font-weight: 500;
    letter-spacing: 1px;
    margin:10px;
}
.information-section p {
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    letter-spacing: 1px;
   
}

.information-section .border{
    width:200px;
    border: rgba(255,0,0,0.1);
    border-style:dashed;
    border-width: 0.5px;
}

.contact-banner {
    position: relative;
    width: 100%;
    height: auto;
}

.contact-banner img {
    width: 100%;
    height: auto;
}

.contact-banner-text {
    position: absolute;
    top: 50%;
    /* Adjust vertical position */
    left: 50%;
    /* Adjust horizontal position */
    transform: translate(-50%, -50%);
    color: #e42727;
    text-align: center;
    
    /* Optional: Adds a semi-transparent background */
    padding: 20px;
    border-radius: 10px;
}

.contact-banner-text h1 {
    font-size: 3rem;
    /* Adjust text size */
    font-weight: bold;
    margin: 0;
}

@media screen and (max-width:768px){
    .contact-container {
            margin-top: 160px;
            display: flex;
            flex-direction: column;
        }
        .contact-details-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .contact-form {
            width: 80%;
            height: 100%;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            background-color: #fff;
            margin: 10px 0px;
            margin-right: 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 10px;
            
    
        }
        .input label {
            text-align: left;
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-top: 5px;
    
        }
        .input-fields {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 0px;
            width:100%;
            margin:0px auto;
        }
        .input {
            width:80%;
            margin: 0px auto;
        }
        .input input{
            width:90%;
        }
        .input select{
            width:90%;
        }
        
        
        .input textarea {
                    height:100%;
                    height:100px;
                    min-height: 0px;
                    width: 90%;
                    padding: 0px;
                }
        .contact-information {
            width: 80%;
            height: 100%;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            background-color: #fff;
            margin: 20px;
           
            display: flex;
            flex-direction: column;
            padding: 10px;
        }
        .contact-form button {
            width: 150px;
            height: 50px;
            margin: 20px 0px;
            background-color: #E42727;
            border-radius: 5px;
            color: #fff;
            position: relative;
            overflow: hidden;
            cursor: pointer;
    
            z-index: 0;
        }

        .contact-banner-text h1 {
            font-size: 1rem;
            /* Adjust text size */
            font-weight: bold;
            margin: 0;
        }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Contact.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf;;AAEJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;;AAEnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;QACZ,eAAe;;QAEf,UAAU;AAClB;;;;;;;AAOA;aACa,mEAAmE;aACnE,WAAW;aACX,kBAAkB;aAClB,OAAO;aACP,MAAM;aACN,YAAY;aACZ,WAAW;aACX,yBAAyB;aACzB,WAAW;;aAEX,yBAAyB;aACzB,sBAAsB;;aAEtB,wDAAwD;;aAExD,6BAA6B;aAC7B,0DAA0D;aAC1D,0DAA0D;SAC9D;;;;SAIA;aACI,sBAAsB;aACtB,0BAA0B;SAC9B;;AAET;OACO,UAAU;QACT,YAAY;QACZ,yCAAyC;QACzC,sBAAsB;QACtB,aAAa;QACb,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,aAAa;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,6BAA6B;IAC7B,SAAS;IACT,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,kBAAkB;;IAElB,iDAAiD;IACjD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI;YACQ,iBAAiB;YACjB,aAAa;YACb,sBAAsB;QAC1B;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;QACvB;QACA;YACI,UAAU;YACV,YAAY;YACZ,yCAAyC;YACzC,sBAAsB;YACtB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,uBAAuB;YACvB,aAAa;;;QAGjB;QACA;YACI,gBAAgB;YAChB,kCAAkC;YAClC,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,mBAAmB;YACnB,eAAe;;QAEnB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;YACnB,eAAe;YACf,UAAU;YACV,eAAe;QACnB;QACA;YACI,SAAS;YACT,gBAAgB;QACpB;QACA;YACI,SAAS;QACb;QACA;YACI,SAAS;QACb;;;QAGA;oBACY,WAAW;oBACX,YAAY;oBACZ,eAAe;oBACf,UAAU;oBACV,YAAY;gBAChB;QACR;YACI,UAAU;YACV,YAAY;YACZ,yCAAyC;YACzC,sBAAsB;YACtB,YAAY;;YAEZ,aAAa;YACb,sBAAsB;YACtB,aAAa;QACjB;QACA;YACI,YAAY;YACZ,YAAY;YACZ,gBAAgB;YAChB,yBAAyB;YACzB,kBAAkB;YAClB,WAAW;YACX,kBAAkB;YAClB,gBAAgB;YAChB,eAAe;;YAEf,UAAU;QACd;;QAEA;YACI,eAAe;YACf,qBAAqB;YACrB,iBAAiB;YACjB,SAAS;QACb;AACR","sourcesContent":[".contact-container{\n    margin-top:110px;\n    display: flex;\n    flex-direction: column;\n}\n\n.contact-details-container{\n    display: flex;\n    flex-direction: row;\n}\n\n.contact-form{\n    width:100%;\n    height:100%;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    background-color: #fff;\n    margin: 20px 100px;\n    margin-right: 50px;\n    display: flex;\n    flex-direction: column;\n    padding: 50px;\n\n}\n\n.contact-form h5{\n    text-align: left;\n    font-family: 'Poppins',sans-serif;\n    font-size: 15px;\n    font-weight: 400px;\n    letter-spacing: 1px;\n    color:#f9c12e;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n}\n\n.contact-form h1 {\n    text-align: left;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    font-weight: 400px;\n    letter-spacing: 1px;\n    margin-top: 0px;\n    color:#333333\n\n}\n\n.input-fields{\n    display: flex;\n    flex-direction: row;\n    margin-top:30px;\n}\n.input{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-right: 20px;\n   \n}\n\n.input label{\n    text-align: left;\n    font-family: 'Raleway',sans-serif;\n    font-size: 16px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 0px;\n    \n}\n\n.input label span{\n    color:red;\n    font-size: 24px;\n    margin-top:10px;\n    margin-left: 10px;\n}\n\n.input input{\n    height:40px;\n    width:275px;\n}\n\n.input select{\n    height:45px;\n    width:275px;\n}\n\n.input textarea {\n    height: 80px;\n    width: 580px;\n}\n\n.contact-form button{\n    width:150px;\n    height:50px;\n    margin: 20px 0px;\n    background-color:#E42727;\n    border-radius: 5px;\n    color:#fff;\n    position: relative;\n    overflow: hidden;\n        cursor: pointer;\n    \n        z-index: 0;\n}\n\n         \n    \n     \n    \n    \n.contact-form button::after {\n             /* this is what all  will be done when mouse outs from the button */\n             content: \"\";\n             position: absolute;\n             left: 0;\n             top: 0;\n             height: 100%;\n             width: 100%;\n             background-color: #ffa406;\n             z-index: -1;\n             \n             transition: 0.3s ease all;\n             transform: scale(0, 1);\n    \n             /* this is you are to change for diffirent transition; */\n    \n             transform-origin: bottom left;\n             transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n             transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n         }\n    \n    \n    \n         .contact-form button:hover::after {\n             transform: scale(1, 1);\n             transform-origin: top left;\n         }\n\n.contact-information{\n       width: 30%;\n        height: 100%;\n        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n        background-color: #fff;\n        margin: 20px ;\n        margin-right:100px;\n        display: flex;\n        flex-direction: column;\n        padding: 50px;\n}\n\n.information-section{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n}\n\n.information-section .icon{\n    background-color:#f9c12e;\n    width:40px;\n    height:40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n\n}\n\n.information-section h5{\n    font-size: 18px;\n    font-family: 'Poppins',sans-serif;\n    font-weight: 500;\n    letter-spacing: 1px;\n    margin:10px;\n}\n.information-section p {\n    font-size: 14px;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    letter-spacing: 1px;\n   \n}\n\n.information-section .border{\n    width:200px;\n    border: rgba(255,0,0,0.1);\n    border-style:dashed;\n    border-width: 0.5px;\n}\n\n.contact-banner {\n    position: relative;\n    width: 100%;\n    height: auto;\n}\n\n.contact-banner img {\n    width: 100%;\n    height: auto;\n}\n\n.contact-banner-text {\n    position: absolute;\n    top: 50%;\n    /* Adjust vertical position */\n    left: 50%;\n    /* Adjust horizontal position */\n    transform: translate(-50%, -50%);\n    color: #e42727;\n    text-align: center;\n    \n    /* Optional: Adds a semi-transparent background */\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.contact-banner-text h1 {\n    font-size: 3rem;\n    /* Adjust text size */\n    font-weight: bold;\n    margin: 0;\n}\n\n@media screen and (max-width:768px){\n    .contact-container {\n            margin-top: 160px;\n            display: flex;\n            flex-direction: column;\n        }\n        .contact-details-container {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n        }\n        .contact-form {\n            width: 80%;\n            height: 100%;\n            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n            background-color: #fff;\n            margin: 10px 0px;\n            margin-right: 0px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            padding: 10px;\n            \n    \n        }\n        .input label {\n            text-align: left;\n            font-family: 'Raleway', sans-serif;\n            font-size: 14px;\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            align-items: center;\n            margin-top: 5px;\n    \n        }\n        .input-fields {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            margin-top: 0px;\n            width:100%;\n            margin:0px auto;\n        }\n        .input {\n            width:80%;\n            margin: 0px auto;\n        }\n        .input input{\n            width:90%;\n        }\n        .input select{\n            width:90%;\n        }\n        \n        \n        .input textarea {\n                    height:100%;\n                    height:100px;\n                    min-height: 0px;\n                    width: 90%;\n                    padding: 0px;\n                }\n        .contact-information {\n            width: 80%;\n            height: 100%;\n            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n            background-color: #fff;\n            margin: 20px;\n           \n            display: flex;\n            flex-direction: column;\n            padding: 10px;\n        }\n        .contact-form button {\n            width: 150px;\n            height: 50px;\n            margin: 20px 0px;\n            background-color: #E42727;\n            border-radius: 5px;\n            color: #fff;\n            position: relative;\n            overflow: hidden;\n            cursor: pointer;\n    \n            z-index: 0;\n        }\n\n        .contact-banner-text h1 {\n            font-size: 1rem;\n            /* Adjust text size */\n            font-weight: bold;\n            margin: 0;\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
